import { ListQuery } from '@onArte/shared/models/common';

export class UserListQuery extends ListQuery {}
